import React, { Dispatch, SetStateAction } from 'react'

export type HandleDeleteCartAndLogoutFunction = (logUserOut: boolean) => Promise<void>

export type LoginProps = {
  user: Nullable<Transformed.LoggedInUser>
  membership: Nullable<Transformed.Membership>
  membershipMeta: Nullable<Transformed.MembershipMeta>
  membershipDetails: Nullable<Transformed.MembershipDetails>
  isLogoutModalOpen: boolean
  setIsLogoutModalOpen: Dispatch<SetStateAction<boolean>>
  handleDeleteCartAndLogout: HandleDeleteCartAndLogoutFunction
  handleLogin: () => void
  loading: boolean
}

const emptyFn = (): void => undefined

export const defaultContext: LoginProps = {
  user: null,
  membership: null,
  membershipMeta: null,
  membershipDetails: null,
  isLogoutModalOpen: false,
  setIsLogoutModalOpen: emptyFn,
  handleDeleteCartAndLogout: (): Promise<void> => Promise.resolve(),
  handleLogin: emptyFn,
  loading: false,
}

const LoginContext = React.createContext<LoginProps>(defaultContext)
export default LoginContext
